/**
 * Giften — header search (Fast Simon autocomplete + Impulse search drawer)
 */
(function () {
  var FS_CONTAINERS = '.fast-ac-container, .mobile-fast-ac-container';

  function forEachNode(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function getHeaderSearchInput() {
    return document.querySelector('.site-header__search input[type="search"]');
  }

  function resetFastSimonVisibility() {
    forEachNode(document.querySelectorAll(FS_CONTAINERS), function (el) {
      el.style.removeProperty('display');
      el.style.removeProperty('visibility');
      el.style.removeProperty('opacity');
      el.style.removeProperty('pointer-events');
      el.removeAttribute('aria-hidden');
    });
  }

  function closeFastSimonAutocomplete() {
    var input = getHeaderSearchInput();
    if (!input) return;

    if (typeof input.closeAutocomplete === 'function') {
      input.closeAutocomplete();
      return;
    }

    input.dispatchEvent(new Event('close-fast-autocomplete', { bubbles: true }));

    forEachNode(document.querySelectorAll(FS_CONTAINERS), function (el) {
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute('aria-hidden', 'true');
    });
  }

  function openFastSimonAutocomplete() {
    var input = getHeaderSearchInput();
    if (!input) return;

    resetFastSimonVisibility();

    if (typeof input.openAutocomplete === 'function') {
      input.openAutocomplete();
    }
  }

  function clearNativePredictiveResults() {
    forEachNode(document.querySelectorAll('.site-header__search #predictive-search'), function (el) {
      el.style.display = 'none';
      el.innerHTML = '';
    });
  }

  function closeHeaderSearch() {
    closeFastSimonAutocomplete();

    forEachNode(document.querySelectorAll('predictive-search'), function (el) {
      el.classList.remove('is-active');
    });

    clearNativePredictiveResults();

    var input = getHeaderSearchInput();
    if (input) {
      input.value = '';
      input.blur();
    }

    document.body.classList.remove('predictive-overflow-hidden');
    document.dispatchEvent(new CustomEvent('predictive-search:close-all', { bubbles: true }));
  }

  function bindCloseControls() {
    forEachNode(document.querySelectorAll('.site-header__search .btn--close-search'), function (btn) {
      if (btn.dataset.giftenCloseBound) return;
      btn.dataset.giftenCloseBound = 'true';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeHeaderSearch();
      });
    });
  }

  function bindSearchOpen() {
    forEachNode(document.querySelectorAll('.js-search-header'), function (btn) {
      if (btn.dataset.giftenOpenBound) return;
      btn.dataset.giftenOpenBound = 'true';
      btn.addEventListener('click', function () {
        clearNativePredictiveResults();
        setTimeout(openFastSimonAutocomplete, 150);
      });
    });
  }

  function bindInputGuard() {
    var input = getHeaderSearchInput();
    if (!input || input.dataset.giftenInputBound) return;
    input.dataset.giftenInputBound = 'true';
    input.addEventListener('input', clearNativePredictiveResults);
  }

  function bindEscapeClose() {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.keyCode !== 27) return;
      var container = document.querySelector('.site-header__search-container.is-active');
      if (!container) return;
      closeHeaderSearch();
    });
  }

  function init() {
    bindCloseControls();
    bindSearchOpen();
    bindInputGuard();
    bindEscapeClose();
    clearNativePredictiveResults();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('predictive-search:open', function (e) {
    if (!e.detail || e.detail.context !== 'header') return;
    clearNativePredictiveResults();
    setTimeout(openFastSimonAutocomplete, 150);
  });
})();
